import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {searchPrintfulProductsSyncsWithSearchCriteria} from "../../services/printful-products-sync-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {
    PRINTFUL_PRODUCTS_SYNC_BATCHES_FIELDS_LIST,
    PRINTFUL_PRODUCTS_SYNC_FIELDS_LIST
} from "../../constants/printful-products-sync.constant";
import {PRINTFUL_INFO_IDS} from "../../constants/printful-info.constant";
import {getSinglePrintfulSyncs} from "../../services/printful-syncs-data.service";
import {showDateTime} from "../../utils/printful-util";

const defaultFilterCriteria: any = {};

const PrintfulProductsSyncsList = () => {
    const [printfulProductsSyncsList, setPrintfulProductsSyncsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPrintfulProductsSyncList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        // const printfulProductsSyncResult = await searchPrintfulProductsSyncsWithSearchCriteria(searchCriteriaList);
        const printfulProductsSyncResult = await getSinglePrintfulSyncs(PRINTFUL_INFO_IDS.PRINTFUL_PRODUCTS_SYNC);

        console.log('printfulProductsSyncResult', printfulProductsSyncResult);

        setPrintfulProductsSyncsList([printfulProductsSyncResult]);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPrintfulProductsSyncList();
    }, [filterCriteria]);

    const refreshPrintfulProductsSyncList = async () => {
        await getPrintfulProductsSyncList();
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Printful Products Sync
                    </div>

                    {/*<PrintfulProductsSyncFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">
                    <div>
                        <button
                            className="button-green px-4 py-2 flex items-center justify-center"
                            onClick={refreshPrintfulProductsSyncList}>
                            <span>Refersh Products Sync</span>
                        </button>
                    </div>
                </div>

            </div>

            <div className="justify-start">

                <div className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={printfulProductsSyncsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Printful Products Syncs'}/>

                    {printfulProductsSyncsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {PRINTFUL_PRODUCTS_SYNC_FIELDS_LIST?.map((printfulProductsSyncField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${printfulProductsSyncField?.cssClass}`}>{printfulProductsSyncField?.label}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody className="">
                            {printfulProductsSyncsList?.map((printfulProductsSync, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PRINTFUL_PRODUCTS_SYNC_FIELDS_LIST?.map((printfulProductsSyncField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${printfulProductsSyncField?.cssClass}`}>
                                                {printfulProductsSyncField?.optionsMap &&
                                                    <>{printfulProductsSyncField?.optionsMap[printfulProductsSync[printfulProductsSyncField?.attribute]]?.name}</>
                                                }

                                                {!printfulProductsSyncField?.optionsMap &&
                                                    <>
                                                        {!printfulProductsSyncField?.isDate && !printfulProductsSyncField?.isBoolean &&
                                                            <>
                                                                {printfulProductsSync[printfulProductsSyncField?.attribute]}
                                                            </>
                                                        }

                                                        {printfulProductsSyncField?.isDate &&
                                                            <>
                                                                {showDateTime(printfulProductsSync[printfulProductsSyncField?.attribute])}
                                                            </>
                                                        }

                                                        {printfulProductsSyncField?.isBoolean &&
                                                            <>
                                                                {printfulProductsSync[printfulProductsSyncField?.attribute] ? 'Yes' : 'No'}
                                                            </>
                                                        }

                                                        {printfulProductsSyncField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {printfulProductsSync[printfulProductsSyncField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }

                </div>

                <div className={'text-xl mt-8'}>Batches</div>

                <div
                    className="w-full bg-white mt-4">

                    {printfulProductsSyncsList && printfulProductsSyncsList[0]?.batches?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {PRINTFUL_PRODUCTS_SYNC_BATCHES_FIELDS_LIST?.map((batchField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${batchField?.cssClass}`}>{batchField?.label}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody className="">
                            {printfulProductsSyncsList[0]?.batches?.map((batch, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PRINTFUL_PRODUCTS_SYNC_BATCHES_FIELDS_LIST?.map((batchField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${batchField?.cssClass}`}>
                                                {batchField?.optionsMap &&
                                                    <>{batchField?.optionsMap[batch[batchField?.attribute]]?.name}</>
                                                }

                                                {!batchField?.optionsMap &&
                                                    <>
                                                        {!batchField?.isDate && !batchField?.isBoolean &&
                                                            <>
                                                                {batch[batchField?.attribute]}
                                                            </>
                                                        }

                                                        {batchField?.isDate &&
                                                            <>
                                                                {showDateTime(batch[batchField?.attribute])}
                                                            </>
                                                        }

                                                        {batchField?.isBoolean &&
                                                            <>
                                                                {batch[batchField?.attribute] ? 'Yes' : 'No'}
                                                            </>
                                                        }

                                                        {batchField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {batch[batchField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default PrintfulProductsSyncsList
